// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#arduino-settings-dialog-container > .dialogBlock {
    height: 531px;
    max-width: 740px !important;
    width: calc(100% - 96px);
}

#arduino-settings-dialog-container > .dialogBlock > .dialogContent {
    justify-content: flex-start;
    overflow: auto;
}

#arduino-settings-dialog-container > .dialogBlock > .dialogControl {
    padding: 16px 0 26px;
}

.arduino-settings-dialog .content {
    padding: 5px;
}

.arduino-settings-dialog .flex-line {
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-wrap: wrap;
}

.arduino-settings-dialog .with-margin {
    margin-left: 5px;
}

.arduino-settings-dialog .theia-select {
    background: var(--theia-input-background) !important;
}

.arduino-settings-dialog .column > div {
    height: 26px;
    vertical-align: middle;
}

.arduino-settings-dialog .column-container {
    display: flex;
    gap: 20px;
}

.arduino-settings-dialog .stretch {
    flex: 1;
}

.arduino-settings-dialog .flex-line .theia-button.shrink {
    min-width: unset;
}

.arduino-settings-dialog .proxy-settings {
    margin: 5px;
}

.arduino-settings-dialog input[type="radio"] {
    margin: 3px !important;
}

.arduino-settings-dialog .theia-input.small {
    max-width: 50px;
    width: 50px;
}

.additional-urls-dialog .link:hover {
    color: var(--theia-textLink-activeForeground);
}

.arduino-settings-dialog .react-tabs__tab--selected {
    background: var(--theia-editorWidget-background);
    border-color: var(--theia-tab-activeBorder);
    color: var(--theia-tab-activeForeground);
    border-radius: 5px 5px 0 0;
}

.arduino-settings-dialog .react-tabs__tab-list {
    border-color: var(--theia-tab-activeBorder);
}

.arduino-settings-dialog .react-tabs__tab-panel {
    padding-bottom: 8px;
}

.arduino-settings-dialog .react-tabs__tab-list {
    display: flex;
    justify-content: center;
}

.additional-urls-dialog textarea {
    resize: none;
    white-space: nowrap;
}

.p-Widget.dialogOverlay .dialogBlock .dialogContent.additional-urls-dialog {
    display: flex;
    overflow: hidden;
    padding: 0 1px;
    margin: 0 -1px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/settings-dialog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;IAChD,2CAA2C;IAC3C,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB","sourcesContent":["#arduino-settings-dialog-container > .dialogBlock {\r\n    height: 531px;\r\n    max-width: 740px !important;\r\n    width: calc(100% - 96px);\r\n}\r\n\r\n#arduino-settings-dialog-container > .dialogBlock > .dialogContent {\r\n    justify-content: flex-start;\r\n    overflow: auto;\r\n}\r\n\r\n#arduino-settings-dialog-container > .dialogBlock > .dialogControl {\r\n    padding: 16px 0 26px;\r\n}\r\n\r\n.arduino-settings-dialog .content {\r\n    padding: 5px;\r\n}\r\n\r\n.arduino-settings-dialog .flex-line {\r\n    display: flex;\r\n    align-items: center;\r\n    white-space: nowrap;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.arduino-settings-dialog .with-margin {\r\n    margin-left: 5px;\r\n}\r\n\r\n.arduino-settings-dialog .theia-select {\r\n    background: var(--theia-input-background) !important;\r\n}\r\n\r\n.arduino-settings-dialog .column > div {\r\n    height: 26px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.arduino-settings-dialog .column-container {\r\n    display: flex;\r\n    gap: 20px;\r\n}\r\n\r\n.arduino-settings-dialog .stretch {\r\n    flex: 1;\r\n}\r\n\r\n.arduino-settings-dialog .flex-line .theia-button.shrink {\r\n    min-width: unset;\r\n}\r\n\r\n.arduino-settings-dialog .proxy-settings {\r\n    margin: 5px;\r\n}\r\n\r\n.arduino-settings-dialog input[type=\"radio\"] {\r\n    margin: 3px !important;\r\n}\r\n\r\n.arduino-settings-dialog .theia-input.small {\r\n    max-width: 50px;\r\n    width: 50px;\r\n}\r\n\r\n.additional-urls-dialog .link:hover {\r\n    color: var(--theia-textLink-activeForeground);\r\n}\r\n\r\n.arduino-settings-dialog .react-tabs__tab--selected {\r\n    background: var(--theia-editorWidget-background);\r\n    border-color: var(--theia-tab-activeBorder);\r\n    color: var(--theia-tab-activeForeground);\r\n    border-radius: 5px 5px 0 0;\r\n}\r\n\r\n.arduino-settings-dialog .react-tabs__tab-list {\r\n    border-color: var(--theia-tab-activeBorder);\r\n}\r\n\r\n.arduino-settings-dialog .react-tabs__tab-panel {\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.arduino-settings-dialog .react-tabs__tab-list {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.additional-urls-dialog textarea {\r\n    resize: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.p-Widget.dialogOverlay .dialogBlock .dialogContent.additional-urls-dialog {\r\n    display: flex;\r\n    overflow: hidden;\r\n    padding: 0 1px;\r\n    margin: 0 -1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
